export const CREATE_MEDICINES = "CREATE_MEDICINES";
export const RETRIEVE_MEDICINES = "RETRIEVE_MEDICINES";
export const RETRIEVESINGLE_MEDICINES = "RETRIEVESINGLE_MEDICINES";
export const UPDATE_MEDICINES = "UPDATE_MEDICINES";
export const DELETE_MEDICINES = "DELETE_MEDICINES";


